<template>
  <v-row class="py-3">
    <v-col class="d-flex align-center" cols="12" md="6">
      <div class="d-flex flex-column">
        <v-card-subtitle v-if="wip" class="title py-0 px-0 grey--text">
          {{  title 
        }}<v-chip x-small class="ml-2" color="info"><span class="black---text">{{$t('sales.clientsList.underDev')}}</span></v-chip></v-card-subtitle>
        <v-card-subtitle v-else class="title py-0 px-0">
          {{  title 
        }}</v-card-subtitle>
        <h5 class="grey--text">{{ subtitle }}</h5>
      </div>
    </v-col>
    <v-col class="d-flex align-center justify-end" cols="12" md="6">
      <div class="d-flex align-center">
        <template v-if="readOnly">
          <div class="pr-3 red--text font-weight-bold" v-if="localSnap == true && reverseValue == true" > {{  disallowText }}</div>
          <div class="pr-3 green--text font-weight-bold" v-if="localSnap == true && reverseValue == false" > {{  allowText}}</div>
          <div class="pr-3 red--text font-weight-bold" v-if="localSnap == false && reverseValue == false" > {{ disallowText }}</div>
          <div class="pr-3 green--text font-weight-bold" v-if="localSnap == false && reverseValue == true" > {{ allowText }}</div>

          <v-btn :disabled="activeEdit" icon @click="enableEditMode">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <div style="width: 150px">
            <v-switch v-model="invertSnap" :label="invertSnap ? allowText : disallowText"></v-switch>
          </div>

          
          <v-btn icon color="success" @click="saveChanges">
            <v-icon>mdi-check-circle-outline</v-icon>
          </v-btn>
          <v-btn icon color="info" @click="cancelChanges">
            <v-icon>mdi-restart</v-icon>
          </v-btn>
        </template>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "switchEditor",
  props: {
    snap: {
      type: [String, Boolean],
      required: true,
    },
    title: {
      type: String,

    },
    updateSnap: {
      type: Number,
      required: false
    },  
    subtitle: {
      type: String,

    },
    activeText: {
      type: String,
      required: false
    },
    inactiveText: {
      type: String,
      required: false
    },
    activeEdit: {
      type: Boolean,
      required: false

    },
    wip: {
      type: Boolean,
      required: false

    },
    reverseValue: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      readOnly: true,
      localSnap :this.snap
    };
  },
  mounted(){
    if(typeof this.snap != 'boolean'){
      this.invertSnap = false
    }
  },
  computed: {

    invertSnap: {
    get() {
      return this.reverseValue == true ?  !this.localSnap : this.localSnap
    },
    set(value) {
      if(this.reverseValue == true){
        this.localSnap = !value;
      }else{
        this.localSnap = value;
      }
     
    }
  },

    allowText(){
      return this.activeText ? this.activeText : this.$t('mainStore.editor.allow')
    },
    disallowText(){
      return this.inactiveText ? this.inactiveText : this.$t('mainStore.editor.disallow')
    }
  },
  watch: {
    updateSnap(){
        this.invertSnap =  this.reverseValue == true ?  !this.snap : this.snap
     
    }
  },
  methods: {
    enableEditMode() {
      this.readOnly = false;
    },
    saveChanges() {
      this.readOnly = true;
      this.$emit("update-form", this.localSnap);
    },
    cancelChanges() {
      this.snapInput = this.snap;
      this.readOnly = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
